import { MOON_BID, SUIT_NAMES, cardName, type GameEvent } from '../engine';

export function describeEvent(e: GameEvent, names: readonly string[]): string | null {
  const n = (i: number) => names[i] ?? `Player ${i + 1}`;
  switch (e.type) {
    case 'handStarted':
      return `— Hand ${e.hand}: ${n(e.dealer)} deals —`;
    case 'bid':
      if (e.amount === 0) return `${n(e.player)} passed.`;
      return e.amount === MOON_BID
        ? `${n(e.player)} is shooting the moon in ${SUIT_NAMES[e.suit!]}!`
        : `${n(e.player)} bid ${e.amount} in ${SUIT_NAMES[e.suit!]}.`;
    case 'bidWon':
      return `${n(e.player)} won the bid: ${e.bid === MOON_BID ? 'the moon' : e.bid} in ${SUIT_NAMES[e.suit]}.`;
    case 'called':
      return `${n(e.player)} called the ${cardName(e.card)}.`;
    case 'kittyTaken':
      return `${n(e.player)} picked up the kitty.`;
    case 'gave':
      return e.count === 0
        ? `${n(e.player)} kept the kitty cards.`
        : `${n(e.player)} passed ${e.count} card${e.count === 1 ? '' : 's'} to the partner.`;
    case 'kept':
      return null;
    case 'played':
      return `${n(e.player)} played the ${cardName(e.card)}.`;
    case 'partnerRevealed':
      return e.partner === null
        ? `${n(e.bidder)} has the ${cardName(e.card)} too, so ${n(e.bidder)} is playing alone.`
        : `${n(e.partner)} has the ${cardName(e.card)}, so ${n(e.partner)} is ${n(e.bidder)}'s partner.`;
    case 'trickWon':
      return `${n(e.player)} won the trick${e.points ? ` (+${e.points})` : ''}.`;
    case 'handScored': {
      const r = e.result;
      const side = r.partner === null ? n(r.bidder) : `${n(r.bidder)} and ${n(r.partner)}`;
      return r.made
        ? `${side} made it with ${r.bidderSidePoints}. Defenders took ${r.defenderPoints}.`
        : `${side} went set (${r.bidderSidePoints} of ${r.bid}). Defenders took ${r.defenderPoints}.`;
    }
    case 'gameOver':
      return e.winners.length === 1 ? `${n(e.winners[0]!)} wins!` : `Tie: ${e.winners.map(n).join(' and ')}!`;
  }
}
